import TheNews from './TheNews.jsx';

export {
  TheNews
}


// WEBPACK FOOTER //
// ./components/my-business/sub-view/the-news/index.js